export class Customer {
  name: string;
  firstSurname: string;
  secondarySurname: string;
  identificationType: string;
  identificationNumber: string;
  streetTypes: string;
  streetName: string;
  streetNumber: string;
  portal: string;
  floor: string;
  door: string;
  postalCode: string;
  locationName: string;
  provinceName: string;
  mobilePhone: string;
  email: string;
  laboralSituationCode: string;
  indPerfilDatExternos: string;
  indPerfilPropPublic: string;
  indPubliPe: string;
  indNoCesionEmpNoGrupo: string;
  indNoCesiEmpGrupo: any;
  constructor(
    name,
    firstSurname,
    secondarySurname,
    identificationType,
    identificationNumber,
    streetTypes,
    streetName,
    streetNumber,
    portal,
    floor,
    door,
    postalCode,
    locationName,
    provinceName,
    mobilePhone,
    email,
    laboralSituationCode,
    indPerfilDatExternos,
    indPerfilPropPublic,
    indPubliPe,
    indNoCesionEmpNoGrupo,
    indNoCesiEmpGrupo
  ) {
    this.name = name;
    this.firstSurname = firstSurname;
    this.secondarySurname = secondarySurname;
    this.identificationType = identificationType;
    this.identificationNumber = identificationNumber;
    this.streetTypes = streetTypes;
    this.streetName = streetName;
    this.streetNumber = streetNumber;
    this.portal = portal;
    this.floor = floor;
    this.door = door;
    this.postalCode = postalCode;
    this.locationName = locationName;
    this.provinceName = provinceName;
    this.mobilePhone = mobilePhone;
    this.email = email;
    this.laboralSituationCode = laboralSituationCode;
    this.indPerfilDatExternos = indPerfilDatExternos;
    this.indPerfilPropPublic = indPerfilPropPublic;
    this.indPubliPe = indPubliPe;
    this.indNoCesionEmpNoGrupo = indNoCesionEmpNoGrupo;
    this.indNoCesiEmpGrupo = indNoCesiEmpGrupo;
  }
}
